module.exports = __webpack_public_path__ + "static/media/exam.bf8f25bc.svg";